
export default () => {
    let links = document.querySelectorAll("a[utm-medium='btn_header_menu'], a[utm-medium='btn_header_menu_buy_now'], a[utm-medium='btn_banner_try_now'], a[utm-medium='blog_exit'], a[utm-medium='btn_footer_menu']");
    if (links.length > 0) {
        for (let url of links) {
            let domain = 'eyezy.com/blog';
            let medium = url.getAttribute('utm-medium');
            let campaign = window.location.pathname === '/' ? 'home' : window.location.pathname.replaceAll('/', '');
            let regexVal = new RegExp("utm-medium");
            if (!regexVal.test(url.getAttribute('href'))) {
                url.setAttribute('href', `${url.getAttribute('href')}?utm_source=${domain}&utm_medium=${medium}&utm_campaign=${campaign}`);
            }
        }
    }
}